import { dialogActions } from '../../services';

export const dialogDispatcher = dispatch => ({
  showDialog : (component, item=null) => dispatch( { type: dialogActions.SHOWDIALOG, component:component, item}),
  closeDialog : () => dispatch( { type: dialogActions.CLOSEDIALOG})
});